import React from 'react';
import { Loading } from '../../../redux/action';
import { connect } from 'react-redux';
import { Methods } from '../../../core/utility/methods';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Launch from '@mui/icons-material/Launch';
import InstagramIcon1 from '../../../components/icons/instagram-icon1';
import { Skeleton } from '@mui/material';
import dayjs from 'dayjs';
import { Card } from '../../../components';
import { CardHeader, CardTitle } from '../../common/analytics/detailed-analytics-new/src/components/ui/card';
import { Avatar, AvatarFallback, AvatarImage } from '../../../components/tailwind-component/ui/avatar';
import { Badge } from '../../../components/tailwind-component/ui/badge';

const methods = new Methods();

interface Props {
  UserReducer: any;
  loading: (data: any) => void;
  profileData: any;
  loader:boolean
}
const BrandPulseProfileCard: React.FC<Props> = (props: Props) => {
  const data = props?.profileData?.[0] || {};

  // Bright Data doesn't return image_count / video_count for every handle, and a
  // missing value lands here as 0 / null / '' -- which rendered as a bare "0" stat
  // that reads like a real count. Hide those tiles instead of showing a false zero.
  const hasCount = (value: any) => Number(value) > 0;

  return (
    <>
      <Card className="p-6 border-[rgba(0,0,0,0.1)] rounded-[14px]">
        <div className="flex flex-col md:flex-row items-start justify-between">
          <div className="flex items-start gap-4 mb-3 md:mb-0">
            <Avatar className="w-20 h-20">
              <AvatarImage src={data?.gcp_profile_image_url} alt={data?.insta_name} />
              <AvatarFallback>ME</AvatarFallback>
            </Avatar>
            <div>
              <h2 className="text-[24px] font-medium text-[#0f172b]">{data?.insta_name}</h2>
              {/* <p className="text-[#155DFC] text-[16px] mb-3">{data?.insta_name}</p> */}
              <a className='brand-insta-name mb-2'
                href={`https://www.instagram.com/${data?.username}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginLeft: '0px', display:'block' }}
              ><span>{data?.username}</span></a>
              <Badge variant="secondary" className="bg-[#ececf0] text-[#030213] text-[12px] font-medium">
                {props.loader ? <Skeleton width={100} height={30}  /> : data?.industry_name}
              </Badge>
            </div>
          </div>
          <div className="flex gap-4 sm:gap-8">
            <div className="text-center">
              <p className="sm-text-[24px] text-[20px] font-medium text-[#0f172b] mb-1">{methods.convertExactNumber(data?.followers)}</p>
              <p className="text-[14px] text-[#45556c]">Total Followers</p>
            </div>
            <div className="text-center">
              <p className="sm-text-[24px] text-[20px] font-medium text-[#0f172b] mb-1">
                {methods.convertExactNumber(data?.media_count)}</p>
              <p className="text-[14px] text-[#45556c]">Total Posts</p>
            </div>
            {/* Previously rendered unconditionally, so an unfetched count showed as "0". */}
            {hasCount(data?.image_count) && (
              <div className="text-center">
                <p className="sm-text-[24px] text-[20px] font-medium text-[#0f172b] mb-1"> {methods.convertExactNumber(data?.image_count)}</p>
                <p className="text-[14px] text-[#45556c]">Total Images</p>
              </div>
            )}
            {hasCount(data?.video_count) && (
              <div className="text-center">
                <p className="sm-text-[24px] text-[20px] font-medium text-[#0f172b] mb-1">{methods.convertExactNumber(data?.video_count)}</p>
                <p className="text-[14px] text-[#45556c]">Total Videos</p>
              </div>
            )}
          </div>
        </div>
      </Card>

        {/* <div className="profile-header" style={{backgroundColor:'#f5fbff',borderRadius:'10px',boxShadow:'0 4px 6px rgba(0, 0, 0, 0.1)'}}>
        <div className="profile-logo">
           {props.loader ? <Skeleton width={287} height={287} variant='circular' /> : 
            <img
              src={data?.gcp_profile_image_url}
              alt={data?.insta_name}
              width={287} height={287}
            />
            }
          </div>
          <div className="profile-info">
            
              <p
                className="profile-info-insta-name"
              >
                {props.loader ? <Skeleton width={100} height={30}  /> : data?.insta_name}
              </p>
              {props.loader ? <Skeleton width={200} height={30}  /> :  
              <div
                className="profile-name"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '2px',
                  marginBottom: '8px',
                }}
              >
                <InstagramIcon1 width={25} />                 <p
                  style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#83A5B0',
                    margin: 0,
                  }}
                >
                  <a className='brand-insta-name'
                  href={`https://www.instagram.com/${data?.username}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginLeft: '0px' }}
                ><span>{data?.username}</span></a>
                </p>
              
            
              </div>
}
                <span className='profile-info-industry-name'>
                {props.loader ? <Skeleton width={100} height={30}  /> : data?.industry_name}
                </span>
          <div className="profile-stats">
              {props.loader ? <Skeleton width={150} height={62}  /> :
              <div
                className="stat-item"
                style={{
                 
                }}
              >
                <strong>
                {methods.convertExactNumber(data?.followers)}
                </strong>
                <span>Followers</span>
              </div>
              }
              {props.loader ? <Skeleton width={150} height={62}  /> :
              <div
                className="stat-item"
                
              >
                <strong
                  
                >
                  {methods.convertExactNumber(data?.media_count)}
                </strong>
                <span>Posts</span>
              </div>
              }
{props.loader ? <Skeleton width={150} height={62}  /> :
              
              <div
                className="stat-item"
                
              >
                <strong
                  
                >
                  {methods.convertExactNumber(data?.image_count)}
                </strong>
                <span>Images</span>
              </div>
            }
              {props.loader ? <Skeleton width={150} height={62}  /> :
              
                <div
                  className="stat-item"
                  
                >
                  <strong  
                  >
                    {methods.convertExactNumber(data?.video_count)}
                  </strong>
                  <span>Videos</span>
                </div>
              }
            </div>
          </div>
          <span className='profile-updated'>{`Last updated on 
          ${dayjs(data.updated_at).format("MMM D, YYYY")}`}
          </span>
          
          
        </div> */}
      
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
  };
};

const connectToRedux = connect(mapStateToProps, mapDispatchToProps)(BrandPulseProfileCard);

export { connectToRedux as BrandPulseProfileCard };
